import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { BaseComponent } from '../../../core/layout/components/abstracts/base.component';

@Component({
  selector: 'app-loader',
  standalone: true,
  imports: [],
  templateUrl: './loader.component.html',
  styleUrl: './loader.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoaderComponent extends BaseComponent {

  @Input() showBackground = false;
  @Input() isAbsolute = false;
  @Input() size: 'lg' | 'md' | 'sm' = 'lg';
}
